export const increasePrices = ({ menu, percentage, excludedSections = [] }) => {
  const multiplier = 1 + percentage / 100;

  const roundToHundred = (value) => Math.round(value / 100) * 100;

  return menu.map((section) => {
    if (excludedSections.includes(section.title)) {
      return section;
    }

    if (section.items) {
      return {
        ...section,
        items: section.items.map((item) => ({
          ...item,
          price:
            typeof item.price === 'number'
              ? roundToHundred(item.price * multiplier)
              : item.price,
        })),
      };
    }

    if (section.subSections) {
      return {
        ...section,
        subSections: section.subSections.map((subSection) => ({
          ...subSection,
          items: subSection.items
            ? subSection.items.map((item) => ({
                ...item,
                price:
                  typeof item.price === 'number'
                    ? roundToHundred(item.price * multiplier)
                    : item.price,
              }))
            : [],
        })),
      };
    }

    return section;
  });
};
